import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Colors, Fonts } from 'styles/constants';

export const Container = styled.nav`
  width: 100%;
  display: flex;
  padding: 16px 24px;
  border-radius: 6px 6px 0 0;
  background-color: ${Colors.White};
  column-gap: 32px;
  overflow-x: auto;
  border-bottom: 2px solid ${Colors.Gray40};
`;

export const Button = styled(Link)`
  font-family: ${Fonts.GilroySemiBold};
  font-size: 14px;
  line-height: 16px;
  white-space: nowrap;
  flex-shrink: 0;
  color: ${Colors.Gray50};
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  transition: 300ms ease;
  gap: 6px;

  .new-feature-star {
    color: ${Colors.Orange};
    font-size: 13px;
  }

  &:hover {
    color: ${Colors.Gray70};
  }

  ::after {
    content: '';
    display: block;
    width: calc(100% + 48px);
    height: 2px;
    background-color: ${Colors.Gray40};
    position: absolute;
    bottom: -18px;
  }

  &.active {
    color: ${Colors.Gray70};

    ::after {
      background-color: ${Colors.Orange};
    }
  }
`;
